import { Text, Box } from "@chakra-ui/react";

const DocumentSearchResult = ({
  searchQuery,
  filterDocuments,
  handleEntityClick,
}: {
  searchQuery: string;
  filterDocuments: any;
  handleEntityClick: any;
}) => {
  const convertKBtoMB = (sizeInKB: any) => {
    return (sizeInKB / 1024).toFixed(2);
  };
  return (
    <Box mt="20px" borderBottom="1px solid #E2E2E2">
      <table>
        <thead>
          <tr>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <Text fontWeight={"600"} fontSize={"12px"} mb={"10px"}>
            Documents
          </Text>
          {searchQuery ? (
            filterDocuments().length > 0 ? (
              filterDocuments().map((document: any) => (
                <tr
                  key={document.id}
                  style={{
                    display: "flex",
                    cursor: "pointer",
                    marginTop: "8px",
                    width: "100%",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.backgroundColor = "#F9F8F8")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.backgroundColor = "white")
                  }
                >
                  <td
                    style={{
                      fontWeight: 500,
                      width: "200px",
                      maxWidth: "300px",
                      color: "#302E34",
                      wordWrap: "break-word",
                      marginLeft: "8px",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                    onClick={() => handleEntityClick("documents", document.id)}
                  >
                    {document.name}
                  </td>
                  <td
                    style={{
                      fontWeight: 500,
                      color: "#B6B3B9",
                      width: "150px",
                      paddingLeft: "70px",
                      marginTop: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    {convertKBtoMB(document.file_size)}MB
                  </td>
                </tr>
              ))
            ) : (
              <tr style={{ height: "92px" }}>
                <td colSpan={2}>
                  <Text mt={"-15px"}>No documents matched.</Text>
                </td>
              </tr>
            )
          ) : (
            <tr style={{ height: "92px" }}>
              <td colSpan={2}>
                <Text mt={"-10px"}>
                  Enter a search query to find documents.
                </Text>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
};

export default DocumentSearchResult;
